module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.list) ? _c('div', {
    staticClass: "content_pages",
    attrs: {
      "id": "report-individual"
    }
  }, [_c('div', {
    staticClass: "table_bordered-header clearfix"
  }, [_c('span', {
    staticClass: "table_bordered-title"
  }, [_c('i', {
    staticClass: "kp-panel-check"
  }), _vm._v("\n      " + _vm._s(_vm.list.quantity_of_submissions) + " " + _vm._s(_vm.$t('report.individual.obtained_answers')) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "content_filter"
  }, [_c('export-button'), _vm._v(" "), _c('date-filter')], 1)]), _vm._v(" "), _c('modal-export-table'), _vm._v(" "), _c('modal-cant-export-table'), _vm._v(" "), _c('modal-export-in-progress', {
    attrs: {
      "email": _vm.reportExportEmail
    }
  }), _vm._v(" "), _c('list')], 1) : _vm._e()
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-2d4ce05b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/report/individual/Main.vue
 ** module id = 789
 ** module chunks = 1
 **/